(function($, undefined) {
	
	'use strict';
    
    var save = function(key,val,lang,callback,reset){
        var ap = actionPath || "/action/";
        
        ajax(ap + "addSiteLabel?lang=" + lang + "&key=" + key +
                "&value=" + (reset ? '' : encodeURIComponent(val)), callback, true);
    };
    
	var init = function (page) {
		var currPage = $(page);      
        
	};
    	
	var labels = Fw.component.export('labels', {
		init: init,
        save: save
	});
	
})(jQuery);